<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-layout xs4 mb-2>
          <v-flex mt-4>
            <h1>Gestão de Notificações</h1>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <hr class="solid" />
    <v-layout column mt-3 class="card">
      <v-row>
        <v-col cols="10">
          <h3>Cadastro de notificação automática</h3>
        </v-col>
        <v-col cols="2">
          <v-btn
            color="primary"
            class="button btn-default white--text"
            @click="acessar(menuRoute('home'))"
            >Voltar</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">Selecione o tipo de notificação automática: </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-switch
            label="Parcela em atraso"
            color="success"
            @change="setTipo(1)"
            v-model="tipo[0]"
            hide-details
          ></v-switch>
          <v-switch
            label="Parcela próximo ao vencimento"
            color="success"
            @change="setTipo(2)"
            v-model="tipo[1]"
            hide-details
          ></v-switch>
          <v-switch
            label="Data próxima assembléia"
            color="success"
            @change="setTipo(3)"
            v-model="tipo[2]"
            hide-details
          ></v-switch>
          <v-switch
            label="Aniversário"
            color="success"
            @change="setTipo(4)"
            v-model="tipo[3]"
            hide-details
          ></v-switch>
          <v-switch
            label="Data personalizada"
            color="success"
            @change="setTipo(5)"
            v-model="tipo[4]"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>
      <v-row v-if="notificacao.tipo === 1">
        <v-col cols="12">
          <v-alert border="bottom" colored-border type="warning" elevation="2">
            <strong>Importante!</strong><br />
            O app obtém as datas de vencimento da parcela e deverá enviar uma
            notificação automaticamente após identificado atraso na parcela"
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="notificacao.tipo === 2">
        <v-col cols="12">
          <v-alert border="bottom" colored-border type="warning" elevation="2">
            <strong>Importante!</strong><br />
            "O app identifica a data de vencimento da parcela e deverá enviar
            uma notificação automática de aviso do vencimento conforme
            quantidade de dias parametrizado"
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="notificacao.tipo === 3">
        <v-col cols="12">
          <v-alert border="bottom" colored-border type="warning" elevation="2">
            <strong>Importante!</strong><br />
            "O app identifica a data de assembléia e deverá enviar uma
            notificação automática de aviso da próxima assembléia conforme
            quantidade de dias parametrizado"
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="notificacao.tipo === 4">
        <v-col cols="12">
          <v-alert border="bottom" colored-border type="warning" elevation="2">
            <strong>Importante!</strong><br />
            "O app obtém a data de nascimento de cada cotista e deverá enviar
            uma notificação automaticamente após identificado o aniversariante"
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="notificacao.tipo === 5">
        <v-col cols="12">
          <v-alert border="bottom" colored-border type="warning" elevation="2">
            <strong>Importante!</strong><br />
            "O app obtém o dia configurado e deverá todo mês enviar uma
            notificação automaticamente"
          </v-alert>
        </v-col>
      </v-row>
      <div v-if="notificacao.tipo !== 0">
        <v-divider class="mt-5 mb-5"></v-divider>
        <v-row>
          <v-col cols="12"> Selecione o meio de envio da notificação: </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-radio-group row v-model="notificacao.meioEnvio">
              <v-radio label="Cota a Cota" value="1"></v-radio>
              <v-radio label="Consorciado" value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-alert border="bottom" colored-border type="warning" elevation="2">
            <strong>Importante!</strong><br />
            "O meio de envio da notificação é aplicado nas situações em que um
            consorciado possuir mais de uma cota. Caso notificado por "cota a
            cota", o mesmo irá receber 'n' notificações para cada uma das suas
            cotas. Caso notificado por "consorciado", o mesmo irá receber 1
            notificação para todas suas cotas"
          </v-alert>
        </v-row>
      </div>
      <div v-if="notificacao.meioEnvio !== '0'">
        <v-divider class="mt-5 mb-5"></v-divider>
        <v-form ref="formFinal" @submit.prevent="salvar">
          <v-row>
            <v-col cols="12">Preencha os dados da notificação: </v-col>
          </v-row>
          <v-row v-if="notificacao.tipo === 2 || notificacao.tipo === 3">
            <v-col cols="3">
              <v-text-field
                label="Quantidade de dias para aviso"
                placeholder="Quantidade de dias para aviso"
                outlined
                type="number"
                min="0"
                max="99"
                v-model="notificacao.quantidadeDiasAviso"
                :rules="
                  notificacao.tipo === 2 || notificacao.tipo === 3
                    ? [rules.required]
                    : []
                "
                @blur="validaQuantidadeDiasAviso"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="notificacao.tipo === 5">
            <v-col cols="2">
              <v-text-field
                label="Dia do Mês"
                placeholder="Dia do Mês"
                outlined
                type="number"
                min="1"
                max="31"
                v-model="notificacao.diaMes"
                :rules="notificacao.tipo === 5 ? [rules.required] : []"
                @blur="validaValorDiaMes"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="Assunto"
                placeholder="Assunto"
                outlined
                v-model="notificacao.assunto"
                :rules="[rules.required, rules.maxLegth100]"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn outlined class="button btn-default" @click="limpar()"
                >Limpar</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-textarea
                outlined
                name="input-7-4"
                label="Corpo da Notificação"
                v-model="notificacao.corpoNotificacao"
                :rules="[rules.required, rules.maxLegth150]"
              ></v-textarea>
            </v-col>
            <v-col cols="2">
              <v-row>
                <v-btn
                  color="primary"
                  class="button btn-default white-text"
                  type="submit"
                  >Cadastrar</v-btn
                >
              </v-row>
              <v-row>
                <v-btn
                  color="primary"
                  fab
                  small
                  dark
                  style="margin-top: 70px"
                  @click="dialog = !dialog"
                >
                  <v-icon>mdi-lightbulb</v-icon>
                </v-btn>
              </v-row>
              <v-row class="mt-5">
                <v-tooltip bottom v-model="dialog" style="max-width: 100px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" style="height: 0px">
                    </v-btn>
                  </template>
                  <span>
                    "Para o cadastro de notificações automáticas as variáveis
                    que substituem
                    <br />valores próprios da cota não irão funcionar.
                    <br />Espera-se apenas uma notificação de texto livre que
                    será disparada <br />para as respectivas cotas
                    configuradas!"
                  </span>
                </v-tooltip>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12"> Ação da Notificação </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-radio-group v-model="notificacao.acao">
                <v-radio label="Nenhuma" value="0"></v-radio>
                <v-radio label="Abrir a tela de Lance" value="1"></v-radio>
                <v-radio label="Abrir a tela do Boleto" value="2"></v-radio>
                <v-radio
                  label="Abrir a tela de Imposto de Renda"
                  value="3"
                ></v-radio>
                <v-radio label="Abrir a tela inicial" value="4"></v-radio>
                <v-radio
                  label="Abrir a tela da central de notificações"
                  value="5"
                ></v-radio>
                <v-radio label="Abrir um link externo" value="6"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="notificacao.acao === '6'">
            <v-col cols="6">
              <v-text-field
                label="Link externo"
                placeholder="Link externo"
                outlined
                v-model="notificacao.linkExterno"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import Rules from "@/plugins/validation";
import { alert, error } from "@/plugins/helpers";
export default {
  name: "NotificacaoAutomatica",
  data: () => ({
    tipo: [false, false, false, false, false],
    notificacao: {
      id: 0,
      tipo: 0,
      meioEnvio: "0",
      assunto: "",
      corpoNotificacao: "",
      acao: "0",
      linkExterno: "",
      quantidadeDiasAviso: 0,
      diaMes: 1,
    },
    dialog: false,
  }),
  methods: {
    menuRoute(name) {
      try {
        const route = this.$router.resolve({ name }).route;
        const selected = this.$route.path.startsWith(route.path);
        return route.matched.length
          ? { text: route.meta.title, to: route.path, selected }
          : { text: "// fixme" };
      } catch (e) {
        return false;
      }
    },
    acessar(item) {
      if (item.click) {
        item.click();
      } else {
        try {
          if (this.$route.path !== item.to) {
            this.$router.push(item.to);
          }
        } catch (e) {
          return false;
        }
      }
    },
    setTipo(id) {
      if (this.tipo[id - 1]) {
        this.tipo = [false, false, false, false, false];
        this.tipo[id - 1] = true;

        this.notificacao.tipo = id;
      } else {
        this.tipo = [false, false, false, false, false];

        this.notificacao.tipo = 0;
      }
    },

    reiniciarFormulario() {
      this.tipo = [false, false, false, false, false];
      this.notificacao = {
        id: 0,
        tipo: 0,
        meioEnvio: "0",
        assunto: "",
        corpoNotificacao: "",
        acao: "0",
        linkExterno: "",
        quantidadeDiasAviso: 0,
        diaMes: 1,
      };
    },

    limpar() {
      this.notificacao = {
        assunto: "",
        corpoNotificacao: "",
        acao: "0",
        linkExterno: "",
        quantidadeDiasAviso: 0,
        diaMes: 1,
      };
    },

    salvar() {
      if (this.$refs.formFinal.validate()) {
        this.notificacao.meioEnvio = parseInt(this.notificacao.meioEnvio);
        this.notificacao.acao = parseInt(this.notificacao.acao);

        this.$http
          .post("/notificacaoAutomatica", this.notificacao)
          .then(() => {
            if (this.notificacao.tipo == 1)
              alert("Notificação automática de parcela em atraso cadastrada com sucesso!");
            else if (this.notificacao.tipo == 2)
              alert("Notificação automática de parcela próximo ao vencimento cadastrada com sucesso!");
            else if (this.notificacao.tipo == 3)
              alert("Notificação automática de aviso da próxima assembleia cadastrada com sucesso!");
            else if (this.notificacao.tipo == 4)
              alert("Notificação automática de aniversário cadastrada com sucesso!");
            else if (this.notificacao.tipo == 5)
              alert("Notificação automática de data personalizada cadastrada com sucesso!");
          })
          .then(() => {
            this.reiniciarFormulario();
          })
          .catch(() => {
            error(null, "Erro ao Cadastrar Notificação");
          });
      } else
        error(null, "Preencha os campos obrigatórios, antes de prosseguir");
    },

    validaValorDiaMes() {
      if (this.notificacao.diaMes > 31) this.notificacao.diaMes = 31;
      if (this.notificacao.diaMes < 1) this.notificacao.diaMes = 1;
    },

    validaQuantidadeDiasAviso() {
      if (this.notificacao.quantidadeDiasAviso > 99)
        this.notificacao.quantidadeDiasAviso = 99;
      if (this.notificacao.quantidadeDiasAviso < 0)
        this.notificacao.quantidadeDiasAviso = 0;
    },
  },
  computed: {
    rules: () => Rules,
  },
};
</script>